export default __webpack_public_path__ + "static/media/crossborder5.e2a88a33.jpg";